import React, { useEffect, useState } from 'react';
import '../../components/errors/ErrorAuth.css';
import authorizeKey from '../../assets/icons/authorizeKey.svg';
import {msalInstance} from '../../index';
import { useNavigate} from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function ErrorAuth(props:any) {
    const { t } = useTranslation();

    const navigate = useNavigate();
    useEffect(() => {
        // let timer1 = setTimeout(() => setShow(true), delay * 1000);
        let timer1 = setTimeout(() => {


                let account=sessionStorage.getItem('loginName') as string
                msalInstance.logoutRedirect({
                    // navigate('/logout')
                    account: msalInstance.getAccountByUsername('/logout')
                }).catch((e:any) => {
                console.log(e);
                });
            
              
        },  5000);

        // this will clear Timeout
        // when component unmount like in willComponentUnmount
        // and show will not change to true
        return () => {
          clearTimeout(timer1);
        };
    })
    
    return (
        <>
            <div className='errordiv'>
                <div className='error'>
                    <img src={authorizeKey} />
                    <h1>Unauthorized Access</h1>
                    <p>{t('you are not a valid user to access the resource')}</p>
                </div>
            </div>
        </>
    )
}


